import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/index";
import Util from "@/utils/utils";
import store from "@/store/store";
import TYPE from "@/store/types";

Vue.use(Router);
const routers = [
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: "/wechat",
    children: [
      {
        path: "/wechat/sign",
        name: "wechatList",
        meta: {
          title: "会议签到",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/home.vue'],resolve)
      },
      {
        path: "/wechat/hospital-sign",
        name: "hospitalList",
        meta: {
          title: "会议签到",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/hospitalHome.vue'],resolve)
      },
      {
        path: "/wechat/typing-register",
        name: "typingList",
        meta: {
          title: "食物过敏临床诊疗调研问卷答题",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/typingRegister.vue'],resolve)
        // component: resolve => require(['@/views/wechat/typingHome.vue'],resolve)
      },
      // {
      //   path: "/wechat/typing-index",
      //   name: "typingIndex",
      //   meta: {
      //     title: "分型问卷答题",
      //     keepAlive: true,
      //     isBack: false
      //   },
      //   component: resolve => require(['@/views/wechat/typingIndex.vue'],resolve)
      // },
      {
        path: "/typing-exam",
        name: "typingExam",
        meta: {
          title: "食物过敏临床诊疗调研问卷",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/typingExam.vue'],resolve)
        // component: resolve => require(['@/views/wechat/typingIndex1.vue'],resolve)
      },
      {
        path: "/wechat/success",
        name: "wechatSuccess",
        meta: {
          title: "签到成功",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/success.vue'],resolve)
      },
      {
        path: "/wechat/typingDuplicate",
        name: "typingDuplicate",
        meta: {
          title: "食物过敏临床诊疗调研问卷",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/typingDuplicate.vue'],resolve)
      },
      {
        path: "/wechat/hospital-success",
        name: "hospitalSuccess",
        meta: {
          title: "签到成功",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/hospitalSuccess.vue'],resolve)
      },
      {
        path: "/wechat/registerSuccess",
        name: "registerSuccess",
        meta: {
          title: "注册成功",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/registerSuccess.vue'],resolve)
      },
      {
        path: "/wechat/submitSuccess",
        name: "submitSuccess",
        meta: {
          title: "提交成功",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/submitSuccess.vue'],resolve)
      },
      {
        path: "/wechat/submitTypingSuccess",
        name: "submitTypingSuccess",
        meta: {
          title: "提交成功",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/submitTypingSuccess.vue'],resolve)
      },
      {
        path: "/wechat/submitHospitalSuccess",
        name: "submitHospitalSuccess",
        meta: {
          title: "提交成功",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/submitHospitalSuccess.vue'],resolve)
      },
      {
        path: "/exam",
        name: "exam",
        meta: {
          title: "问卷调研",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/exam.vue'],resolve)
      },
      {
        path: "/qrcode",
        name: "qrcode",
        meta: {
          title: "二维码",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/qrcode.vue'],resolve)
      },
      {
        path: "/detail",
        name: "detail",
        meta: {
          title: "会议详情",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/detail.vue'],resolve)
      },
      {
        path: "/cityexam",
        name: "cityexam",
        meta: {
          title: "会议详情",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/cityexam.vue'],resolve)
      },
      {
        path: "/hospital-exam",
        name: "hospitalExam",
        meta: {
          title: "标杆医院详情",
          keepAlive: true,
          isBack: false
        },
        component: resolve => require(['@/views/wechat/hospitalexam.vue'],resolve)
      },
      // {
      //   path: "/typing-exam",
      //   name: "typingExam",
      //   meta: {
      //     title: "分型问卷详情",
      //     keepAlive: true,
      //     isBack: false
      //   },
      //   component: resolve => require(['@/views/wechat/typingexam.vue'],resolve)
      // }
    ]
  },
  {
    path: "*",
    redirect: "/wechat/sign"
  }
];

const RouterConfig = {
  mode: "hash",
  routes: routers
};

/**
 * 设置浏览器头部标题
 */
export const setTitle = function (title) {
  title = title ? `${title}` : '会议签到'
  window.document.title = title
}


const router = new Router(RouterConfig);




router.afterEach(to => {
  setTimeout(() => {
    let browserHeaderTitle = to.meta.title;
    setTitle(browserHeaderTitle);
  }, 0);
});

export default router;
